export default "__VITE_ASSET__EBR159NT__"